import React from 'react';
import { ImgUploaderForStyleSettings } from 'components/ImgUploader/ImgUploaderForStyleSettings';
import style from './CarouselItem.module.scss';

interface IProps {
	filePath: Nullable<string>;
	translationId: string;
	sourceUrl: string;
	isMakeImageRequest: boolean;
}

export const CarouselImgItem: React.FC<IProps> = React.memo(
	({ filePath, translationId, sourceUrl, isMakeImageRequest }) => {
		return (
			<>
				{filePath ? (
					<ImgUploaderForStyleSettings
						translationID={translationId}
						photoSize="Medium"
						isMakeImageRequest={isMakeImageRequest}
						loaderSize="big"
						noImageIdIcon="twoHills"
						isUseInSlider={true}
					/>
				) : (
					<img className={style.emblaSlideItem} src={sourceUrl} alt="Some photo" />
				)}
			</>
		);
	},
);
